// Copyright (c) Microsoft Corporation.
// Licensed under the MIT License.

import { TableCellLayout } from '@fluentui/react-components';
import { CurriculumState } from '@microsoft/vscodeedu-api';
import React from 'react';
import { injectIntl } from 'react-intl';
import { Indicator, IntlProps } from '../common';
import { getCurriculumStateText } from './curriculum-state-text';

// Curriculum status cell properties.
export type StatusCellProps = IntlProps<{
    value: CurriculumState;
}>;

// Curriculum state grid cell contents.
export default injectIntl((props: StatusCellProps) => {
    const { intl, value } = props;
    const text = getCurriculumStateText(intl, value);
    const showSpinner = value !== 'draft' && value !== 'published';
    return (
        <TableCellLayout>
            {showSpinner && <Indicator type="spinner">{text}...</Indicator>}
            {!showSpinner && text}
        </TableCellLayout>
    );
});
